import type { FaireProductEntity } from "../../entity_types/product";

export const p_y9x9nhjp6a: FaireProductEntity = {
  token: "p_y9x9nhjp6a",
  type: "product",
  name: "Women's Ultra Soft Plush Cable Knit Winter Scarf",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/0e8b8b0a2dafffbc2f5ad8ca7135c50700f30199cb43a86b78356b5b3533347f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ca294a927e003bcaeb97a76e635cbe3126db74304add8e3128c740562b83b1b.jpeg",
    "https://cdn.faire.com/fastly/7a4e02ed0151fad45916f087e792caf0cb3048c24424a35a2527788fa5719cbf.jpeg",
    "https://cdn.faire.com/fastly/fa0a821f660ebbb77bd9db8790a2533222933f4b33aade0ebb4bff34fb08d8ff.jpeg",
    "https://cdn.faire.com/fastly/02fc16e6c06923a6569ef2df3dd0cdc252044a4b9d8d6cc837f2b375e4c29f12.jpeg",
    "https://cdn.faire.com/fastly/f504925d28559a561bf92d6ee11a751fc5ca9a01f06b2f64b95c593c445f3029.jpeg",
    "https://cdn.faire.com/fastly/9f3ebc54ab9751ed7949babc5672ccd058263668b1c38b5eee7bebc2bcba119f.jpeg",
    "https://cdn.faire.com/fastly/56cf15cfb3fca7c8eba33a6910b513c0a57a76d6a91a3226a5de0922fbc65e91.jpeg",
    "https://cdn.faire.com/fastly/15b2e8764e758127813ebf9eb23ad6c80e5e443d41ac01c246e9dbb3177d04c1.jpeg",
    "https://cdn.faire.com/fastly/f437031bf4a32d91a4cda15be32e7894983a50e37e0695c1c6d6b3eeed2bf1ab.jpeg"
  ],
  priceDollars: 41,
  description: "Irresistibly soft comfort and a touch of cozy luxury to every cold-weather look. Designed to feel as good as it looks, it's the accessory you'll reach for all season long.\n\nFabrication:\nMade from Softies' signature Cable Knit Marshmallow fabric, this scarf combines classic cable-knit texture with an ultra-plush handfeel. \n\nFeatures:\n● Classic scarf silhouette for versatile styling\n● Cable-knit texture adds dimension and timeless appeal\n● Lightweight yet cozy design provides comfortable warmth\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Layering during chilly weather\n● Travel and everyday wear\n● Thoughtful gifting throughout the season\n",
  tags: [],
  msrpDollars: 82,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:09.220Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
